import { useState, useEffect } from 'react';
import RagnaWindow from '../ReactComponents/RagnaWindow.jsx';
import { RMultiTab } from '../ReactComponents/RMultiTab.jsx';
import RagnaLoader from '../ReactComponents/RagnaLoader';
import { s2ab, canBeViewedWeb } from '../ReactGlobals.js';
import { _basename, ajax_api } from '../../Globals.jsx';
import moment from 'moment';
import axios from 'axios';
import { useLoaderData, useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Document, Page, pdfjs } from 'react-pdf';
import RichTextEditor from '../ReactComponents/RichTextEditor.jsx';

pdfjs.GlobalWorkerOptions.workerSrc = _basename + 'plugins/pdfjs/pdf.worker.js';

const SPItemView = props => {
    const [loaded, setLoaded] = useState(false);
    const [currentPdfPage, setCurrentPdfPage] = useState(1);
    const [numPages, setNumPages] = useState(0);

    const [errorState, setErrorState] = useState(false);
    const [excerpt, setExcerpt] = useState(null);
    const [existingDocUrl, setExistingDocUrl] = useState("");
    const [attachmentsUrl, setAttachmentsUrl] = useState([]);
    const [scannedUrl, setScannedUrl] = useState();
    const { Id } = useLoaderData();

    const loadData = _ => {
        setErrorState(false);
        axios.get(ajax_api + "items", {
            params: {
                id: Id,
                editMode: props.editMode
            },
            withCredentials: true
        }).then(r => {
            return r.data;
        }).then(d => {
            setExcerpt(d);
        }).catch(e => {
            setErrorState(true);
            console.log(e);
        })
    }

    useEffect(loadData, []);

    useEffect(_ => {
        if (excerpt) {
            var docUrl = "";
            var scanUrl = "";
            var arr = [];

            if (excerpt.FilePath) {
                var file;
                var fileExtension = excerpt.DocumentFileName.split(".").pop();
                var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                file = new Blob([s2ab(atob(excerpt.FilePath))], { type: fileType });
                docUrl = URL.createObjectURL(file);
                setExistingDocUrl(docUrl);
                // free memory when ever this component is unmounted
            }
            if (excerpt.ItemScan) {
                var file;
                var fileExtension = excerpt.ScannedFileName.split(".").pop();
                var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                file = new Blob([s2ab(atob(excerpt.ItemScan))], { type: fileType });
                scanUrl = URL.createObjectURL(file);
                setScannedUrl(scanUrl);
                // free memory when ever this component is unmounted
            }
            //set file attachments
            if (excerpt.Attachments) {
                (async function () {
                    await excerpt.Attachments.forEach(attachment => {
                        var file;
                        var fileExtension = attachment.filename.split(".").pop();
                        var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                        file = new Blob([s2ab(atob(attachment.file))], { type: fileType });
                        arr.push(URL.createObjectURL(file));
                    })
                })();
                setAttachmentsUrl(arr);
            }
            setLoaded(true);
            return _ => {
                URL.revokeObjectURL(docUrl);
                URL.revokeObjectURL(scanUrl);
                arr.forEach(u => URL.revokeObjectURL(u))
            }
        }
    }, [excerpt])

    return <>
        <Helmet>
            <title>LTS | View SP Item</title>
        </Helmet>
        <RagnaWindow
            minHeight={300}
            title={props.EditMode ? "Edit SP Item" : "SP Item Details"}
            footer={
                null
            }
            footer_options={
                null
            }
            mainStyle={{
                width: "100%",
                maxWidth: props.width ? props.width : "100%",
                transition: "all .1s"
            }}
            boxStyle={
                null
            }
        >
            {
                errorState ?
                    <div style={{ textAlign: 'center' }}>
                        An error occured. Check console for details. <a href="#" onClick={_ => loadData()}> Click here to reload</a>
                    </div>
                    : (loaded == false ?
                        <RagnaLoader /> :
                        (
                            excerpt == null ?
                                "SP Item not found!" : <RMultiTab linear={true} contents={
                                    [
                                        {
                                            title: <><i className="fa fa-list"></i> Item Details</>,
                                            content:
                                                <div className="excerpt-view">
                                                    <div>
                                                        <div>
                                                            <div>Item Type:</div>
                                                            <div>{excerpt.ItemType}</div>
                                                            <div>Item Code:</div>
                                                            <div>{excerpt.ItemCode}</div>
                                                        </div>
                                                        <div>
                                                            <div>Enacted Date:</div>
                                                            <div>{excerpt.EnactedDate == null ? "null" : moment(excerpt.EnactedDate).format("MMMM D, yyyy")}</div>
                                                            <div>Approved Date:</div>
                                                            <div>{/*excerpt.Approved*/true ? excerpt.EnactedDate == null ? "null" : moment(excerpt.ApprovedDate).format("MMMM D, yyyy") : "Not yet approved"}</div>
                                                        </div>
                                                    </div>
                                                    <div className="no-half">
                                                        <div>Title:</div>
                                                        <div style={{ textIndent: "2vw" }}>{excerpt.Title}</div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <div>Council:</div>
                                                            <div>{excerpt.Council ?? "-not set-"}</div>
                                                        </div>
                                                        <div>
                                                            <div>Session:</div>
                                                            <div>{excerpt.Session ?? "-not set-"}</div>
                                                        </div>
                                                    </div>
                                                    <div className="no-half">
                                                        <div>Item Content:</div>
                                                        <div style={{ whiteSpace: "pre-wrap" }}>{excerpt.ItemContent}</div>
                                                    </div>
                                                </div>
                                        },
                                        {
                                            title: <><i className="fa fa-user"></i> Author/CoAuthors</>,
                                            content: <div>
                                                <div className="row">
                                                    <div className="col-12 col-md-6 mb-2">
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            fontSize: "0.9em",
                                                            textDecoration: "underline"
                                                        }}>
                                                            Author:
                                                        </div>
                                                        <div>
                                                            {/*{*/}
                                                            {/*    excerpt.Author ?*/}
                                                            {/*        (*/}
                                                            {/*            excerpt.Author.trim() === "" ?*/}
                                                            {/*        "-No Main Author-" : excerpt.Author ) : "-No Main Author-"*/}
                                                            {/*}*/}

                                                            {
                                                                excerpt.AuthorList.length == 0 ? "-No Authors-" :
                                                                    excerpt.AuthorList.map(author => <div>{author}</div>)
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            fontSize: "0.9em",
                                                            textDecoration: "underline"
                                                        }}>
                                                            CoAuthor/s:
                                                        </div>
                                                        <div>
                                                            {
                                                                excerpt.CoAuthor.length == 0 ? "-No CoAuthors-" :
                                                                    excerpt.CoAuthor.map(author => <div>{author}</div>)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        },
                                        {
                                            title: <><i className="fa fa-users"></i> Categories/Committees</>,
                                            content: <div>
                                                <div className="row">
                                                    <div className="col-12 col-md-6 mb-2">
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            fontSize: "0.9em",
                                                            textDecoration: "underline"
                                                        }}>
                                                            Categories:
                                                        </div>
                                                        <div>
                                                            {
                                                                excerpt.Category.length == 0 ? "-No Category-" :
                                                                    excerpt.Category.map(c => <div>{c}</div>)
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            fontSize: "0.9em",
                                                            textDecoration: "underline"
                                                        }}>
                                                            Committees:
                                                        </div>
                                                        <div>
                                                            {
                                                                excerpt.Committee.length == 0 ? "-No Committee-" :
                                                                    excerpt.Committee.map(c => <div>{c}</div>)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        },
                                        {
                                            title: <><i className="fa fa-file-word"></i> Document File</>,
                                            content: <>
                                                {
                                                    <div>
                                                        {
                                                            excerpt.DocumentFileName == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER</div> :
                                                                (excerpt.FilePath && excerpt.FilePath != "" ?
                                                                    <a href={existingDocUrl} download={
                                                                        canBeViewedWeb(excerpt.DocumentFileName.split(".").pop())
                                                                            ? null : excerpt.ItemType + "-" + excerpt.ItemCode + "-Document." + excerpt.DocumentFileName.split(".").pop()//excerpt.DocumentFileName
                                                                    } target="blank"><i className={canBeViewedWeb(excerpt.DocumentFileName.split(".").pop()) ? 'fa fa-external-link' : 'fa fa-download'}></i> {excerpt.ItemType + "-" + excerpt.ItemCode + "-Document." + excerpt.DocumentFileName.split(".").pop()}</a>
                                                                    : "-no uploaded file-")
                                                        }
                                                    </div>
                                                }

                                            </>
                                        },
                                        {
                                            title: <><i className="fa fa-files"></i> File Attachments</>,
                                            content: <>
                                                {
                                                    <div>
                                                        {
                                                            excerpt.Attachments?.forEach((attachment, index) => {
                                                                var url = attachmentsUrl[index];
                                                                var filename = attachment.filename;
                                                                var guid_length = 37; //only 36 but add 1 for the additional dash
                                                                var filename_start_length = `attachment-${excerpt.ItemCode}-${index}-`.length + guid_length;
                                                                var filename_fixed = filename.substring(filename_start_length);
                                                                if (url == undefined) return;

                                                                return <div key={`attachment-${index}`}>
                                                                    {
                                                                        filename == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER. UNABLE TO RETRIEVE THIS FILE.</div> :
                                                                            <a href={url} download={
                                                                                canBeViewedWeb(filename.split(".").pop())
                                                                                    ? null : filename_fixed
                                                                            } target="blank"><i className={canBeViewedWeb(filename.split(".").pop()) ? 'fa fa-external-link' : 'fa fa-download'}></i> {filename_fixed}</a>

                                                                    }
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                }

                                            </>
                                        },
                                        {
                                            title: <><i className="fa fa-scanner-image"></i> Scanned Document</>,
                                            content: <>
                                                {
                                                    excerpt.ScannedFileName == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER</div> :
                                                        (
                                                            excerpt.ScannedFileName.split(".").pop() == "pdf" ?
                                                                (
                                                                    <>
                                                                        {
                                                                            //view pdf on new tab (for printing)
                                                                            <a href={scannedUrl} target="blank"><i className="fa fa-print"></i> {excerpt.ItemType + "-" + excerpt.ItemCode + "-Scanned." + excerpt.ScannedFileName.split(".").pop()}</a>
                                                                        }
                                                                        {
                                                                            //scanned document pagination navigation (?)
                                                                            <div className='pt-2 text-center mb-2'>
                                                                                <button className='btn btn-secondary'
                                                                                    disabled={currentPdfPage <= 1}
                                                                                    onClick={_ => setCurrentPdfPage(p => p == 1 ? 1 : p - 1)}>PREV</button>
                                                                                <span className='mx-2'>
                                                                                    Page {currentPdfPage} of {numPages}
                                                                                </span>
                                                                                <button className='btn btn-secondary'
                                                                                    disabled={currentPdfPage >= numPages}
                                                                                    onClick={_ => setCurrentPdfPage(p => p >= numPages ? numPages : p + 1)}>NEXT</button>

                                                                            </div>
                                                                        }
                                                                        <Document
                                                                            onLoadError={console.error}
                                                                            file={scannedUrl}
                                                                            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                                                                            className="import-pdf-page bg-secondary p-2 d-flex justify-content-center"
                                                                            style={{
                                                                                background: '#ccc'
                                                                            }}
                                                                        >
                                                                            {
                                                                                (Array.apply(null, Array(numPages))
                                                                                    .map((x, i) => i + 1))
                                                                                    .map(page => {
                                                                                        return <>
                                                                                            <Page
                                                                                                className={
                                                                                                    (page != currentPdfPage ? "d-none" : "")
                                                                                                    + " shadow-lg"}
                                                                                                pageNumber={page}
                                                                                                key={`scanned-page-${page}`} />
                                                                                        </>
                                                                                    })

                                                                            }
                                                                        </Document>
                                                                    </>
                                                                ) :
                                                                <img src={`data:image/png;base64,${excerpt.ItemScan != "" ? excerpt.ItemScan :
                                                                    excerpt.ItemScanUrl}`} alt="scanned_photo" />
                                                        )
                                                }

                                            </>
                                        },
                                        {
                                            title: <><i className="fa fa-book"></i> Document Editor</>,
                                            content: <>

                                                <RichTextEditor
                                                    initialValue={excerpt?.DocEditorContent ?? ""}
                                                    readOnly={true} />

                                            </>
                                        }
                                    ]} />
                        ))
            }
        </RagnaWindow >
    </>
}

export default SPItemView;